import React, {Component} from "react";
import Header from "../../../Containers/Header/Header";
import Footer from "../../../Containers/Footer";

class AdminSetting extends Component {
    render() {
        return (
            <div className="beaconWrapper">
                <Header selectedIndex={2}/>
                <div className="allconWrapper">
                    <div className="contentsWrapper">
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}
export default AdminSetting;



// WEBPACK FOOTER //
// ./src/components/Pages/Teacher/AdminSetting/index.js